import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		//ApiUtils.getLoadingAjax(constant.serverUrl + "/study/selfevaluation/list", params, successCallback, failCallback, exceptionCallback);
		ApiUtils.getLoadingAjax(constant.serverUrl + "/study/selfevaluation/list", params, successCallback, failCallback, exceptionCallback);
	},
	listCname: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/study/selfevaluation/listCname", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/study/selfevaluation/save", params, successCallback, failCallback, exceptionCallback);
	},
	saveDTO: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/study/selfevaluation/saveDTO", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/study/selfevaluation/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/study/selfevaluation/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/study/selfevaluation/remove", params, successCallback, failCallback, exceptionCallback);
	},
	readst: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/study/selfevaluation/updateReadst", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
